import { getBusinesses } from '../../../data/repositories/businessRepository.js';
import { transformBusinessForMap } from './transformBusinessForMap.js';

/**
 * Search businesses by location (geo-coordinates)
 * @param {number} latitude - Latitude coordinate
 * @param {number} longitude - Longitude coordinate
 * @param {number} distance - Distance in meters (default: 80000 = 80km)
 * @param {string[]} categoryIds - Optional category IDs to filter by
 * @param {number} page - Page number (default: 1)
 * @param {number} take - Number of results per page (default: 100)
 * @returns {Promise<{businesses: Array, hasNext: boolean}>}
 */
export const searchBusinessesByLocationForMap = async (
  latitude,
  longitude,
  distance = 80000,
  categoryIds = [],
  page = 1,
  take = 100
) => {
  const params = {
    page: String(page),
    take: String(take),
    'geoPoints[0]': [latitude, longitude],
    distance: String(distance),
    sortByDistance: 'ASC',
    maxRating: '5',
  };

  // Add category IDs if provided
  if (categoryIds && categoryIds.length > 0) {
    categoryIds.forEach((id, index) => {
      params[`categoryIds[${index}]`] = id;
    });
  }

  const result = await getBusinesses(params);
  const businesses = result.data || [];
  return {
    businesses: businesses.map(transformBusinessForMap),
    hasNext: result.meta?.hasNext || false,
  };
};
